// German translations
export const de = {
  // Navigation
  nav: {
    home: 'Startseite',
    services: 'Leistungen',
    forPartners: 'Für Partner',
    aboutUs: 'Über uns',
    contact: 'Kontakt',
    bookStrategyCall: 'Strategiegespräch buchen',
  },

  // Hero Section
  hero: {
    badge: 'Ihr Wachstum — Unsere Verantwortung',
    title: 'Lead-Generierung',
    titleHighlight: 'Unternehmen',
    description:
      'Wir liefern hochwertige, DSGVO-konforme Leads durch Premium-Traffic-Funnels und Performance-Kanäle.',
    getStarted: 'Jetzt starten',
    exploreServices: 'Leistungen entdecken',
    trustedBy: 'Mehr als 50+ Unternehmen vertrauen uns',
  },

  // Stats
  stats: {
    leadsGenerated: 'Kundenbetreuung',
    withPartners: 'Mit unseren Partnern',
    campaignsDelivered: 'Durchgeführte Kampagnen',
    emailDeliverability: 'E-Mail-Zustellbarkeit',
    gdprCompliant: 'DSGVO-konform',
  },

  // Partners Section
  partners: {
    title: 'Unsere Werbeplattform-Partner',
  },

  // Live Counter
  liveCounter: {
    badge: 'Live-Metriken',
    title: 'Werbeinvestition',
    updating: 'Aktualisierung in Echtzeit',
    description:
      'Dynamisch berechnet auf Basis unserer täglichen Werbeinvestitionen mit vertrauenswürdigen Partnern.',
    dailyInvestment: 'Tägliche Investition',
    perSecond: 'Pro Sekunde',
    activeCampaigns: 'Aktive Kampagnen',
  },

  // Services Section
  services: {
    badge: 'Unsere Leistungen',
    title: 'Premium Lead-Generierung',
    subtitle: 'End-to-End Performance-Marketing-Lösungen für den Markterfolg.',
    viewAll: 'Alle Leistungen anzeigen',
    items: {
      coReg: {
        title: 'Co-Registrierung Leads',
        shortDesc:
          'Hochkonvertierende mehrstufige Registrierungsabläufe zur Erfassung qualifizierter Nutzerintention.',
        fullDesc:
          'Unsere Co-Registrierungsfunnels sind darauf ausgelegt, die Konversion zu maximieren und gleichzeitig die Datenqualität zu gewährleisten. Nutzer stimmen während ihrer Registrierung dem Erhalt von Informationen Ihrer Marke zu.',
      },
      coSpo: {
        title: 'Co-Sponsoring Leads',
        shortDesc:
          'Premium-Platzierungen in Partner-Registrierungsabläufen für maximale Sichtbarkeit.',
        fullDesc:
          'Nutzen Sie unser Netzwerk von Premium-Publisher-Partnern, um hochengagierte Zielgruppen zu erreichen. Gesponserte Platzierungen stellen sicher, dass Ihre Marke prominent erscheint.',
      },
      email: {
        title: 'E-Mail-Marketing',
        shortDesc: 'gestützte Kampagnen mit branchenführenden Zustellraten.',
        fullDesc:
          'Unser proprietäres E-Mail-Delivery-System auf Basis von AWS SES stellt sicher, dass Ihre Nachrichten den Posteingang erreichen. Erweiterte Segmentierung und Optimierung maximieren Engagement und ROI.',
      },
      sms: {
        title: 'SMS DOI Funnels',
        shortDesc: 'Double-Opt-In SMS-Kampagnen mit Echtzeit-Zustellung und Tracking.',
        fullDesc:
          'Erreichen Sie Kunden direkt auf ihren Mobilgeräten mit konformem SMS-Marketing. Unser DOI-Prozess gewährleistet echte Einwilligung und hohe Engagement-Raten.',
      },
      leadAcquisition: {
        title: 'Lead-Akquise',
        shortDesc: 'Ansprechende Kampagnen, die massives qualifiziertes Lead-Volumen generieren.',
        fullDesc:
          'Unsere Lead-Akquise-Kampagnen kombinieren attraktive Angebote mit strategischem Targeting, um hohe Volumen qualifizierter Leads bei gleichbleibender Datenqualität zu generieren.',
      },
      phone: {
        title: 'Telefon-Lead-Lieferung',
        shortDesc: 'Echtzeit-validierte Telefon-Leads mit garantierten Kontaktraten.',
        fullDesc:
          'Wir liefern telefonverifizierte Leads mit Echtzeit-Validierung für höchste Genauigkeit. Direkte Integration mit Ihrem CRM für nahtlosen Lead-Flow.',
      },
      data: {
        title: 'Datenmonetarisierung & Segmentierung',
        shortDesc: 'Erweiterte Zielgruppensegmentierung für Präzisions-Targeting.',
        fullDesc:
          'Wandeln Sie Rohdaten in umsetzbare Segmente um. Unsere erweiterte Analytik identifiziert hochwertige Zielgruppen-Cluster für maximale Kampagneneffektivität.',
      },
      api: {
        title: 'API-Lieferung & Echtzeit-Validierung',
        shortDesc: 'Nahtlose Integration mit sofortiger Lead-Lieferung und Verifizierung.',
        fullDesc:
          'Unsere robuste API-Infrastruktur ermöglicht Echtzeit-Lead-Lieferung mit sofortiger Validierung. Reduzieren Sie Betrug und verbessern Sie automatisch die Datenqualität.',
      },
    },
  },

  // USPs Section
  usps: {
    badge: 'Warum wir',
    title: 'Warum Avalon X Media?',
    subtitle: 'Die Wettbewerbsvorteile, die uns in der Lead-Generierung auszeichnen.',
    tagline: 'Wir erschaffen, was andere verkaufen. Ihre vertrauenswürdige Quelle.',
    items: {
      directSource: {
        title: 'Direkte Quelle',
        description: '100% First-Party deutsche Leads aus unserem proprietären Traffic-Netzwerk.',
      },
      gdprCompliant: {
        title: 'DSGVO-konform',
        description:
          'Vollständige regulatorische Compliance mit transparentem Einwilligungsmanagement.',
      },
      highDeliverability: {
        title: 'Hohe Zustellbarkeit',
        description: 'Branchenführende E-Mail-Zustellraten.',
      },
      realTimeValidation: {
        title: 'Echtzeit-Validierung',
        description: 'Sofortige Verifizierung gewährleistet Datengenauigkeit und reduziert Betrug.',
      },
      customFunnels: {
        title: 'Individuelle Funnels',
        description: 'Maßgeschneiderte Akquisitionsabläufe für Ihre spezifische Branche und Ziele.',
      },
      transparentReporting: {
        title: 'Transparentes Reporting',
        description: 'Echtzeit-Dashboards mit vollständiger Kampagnentransparenz.',
      },
    },
  },

  // Verticals Section
  verticals: {
    badge: 'Branchenexpertise',
    title: 'Individuelle Funnels für jedes Produkt',
    subtitle:
      'Wir sind spezialisiert auf leistungsstarke Lead-Generierung in den wettbewerbsintensivsten Branchen der Welt.',
    items: ['Finanzen', 'Versicherung', 'E-Commerce', 'Einzelhandel', 'Mobilität', 'FMCG'],
    metrics: {
      conversionRate: 'Durchschn. Konversionsrate',
      avgCpl: 'Durchschn. CPL',
      emailDeliverability: 'E-Mail-Zustellbarkeit',
      reachPerMonth: 'Reichweite pro Monat',
    },
  },

  // Compliance Section
  compliance: {
    badge: 'Compliance & Vertrauen',
    title: '100% DSGVO-konform',
    subtitle:
      'Wir nehmen Datenschutz ernst. Jeder Lead wird mit ausdrücklicher Einwilligung und vollständiger regulatorischer Compliance erfasst.',
    items: [
      'Transparentes Einwilligungsmanagement',
      'Echtzeit-Datenvalidierung',
      'Vollständige Audit-Trail-Dokumentation',
      'Regelmäßige Compliance-Audits',
      'Auftragsverarbeitungsvertrag (AVV) bereit',
    ],
    cards: {
      gdpr: { label: 'DSGVO-konform', desc: 'Vollständiger EU-Datenschutz' },
      doi: { label: 'DOI-verifiziert', desc: 'Double-Opt-In-Prozess' },
      secure: { label: 'Sichere Daten', desc: 'Verschlüsselte Übertragung' },
      documented: { label: 'Dokumentierte Einwilligung', desc: 'Vollständiger Audit-Trail' },
    },
  },

  // CTA Section
  cta: {
    title: 'Bereit, Ihre Lead-Generierung zu skalieren?',
    subtitle:
      'Lassen Sie uns besprechen, wie Avalon X Media Ihnen helfen kann, hochwertige, DSGVO-konforme Leads für Ihr Unternehmen zu gewinnen.',
    requestLeadFlow: 'Lead-Flow anfragen',
    learnMore: 'Mehr erfahren',
  },

  // Services Page
  servicesPage: {
    badge: 'Unsere Leistungen',
    title: 'Umfassende Lead-Generierung',
    subtitle:
      'Von Co-Registrierungsfunnels bis zur Echtzeit-API-Lieferung bieten wir End-to-End-Lösungen für deutsche Werbetreibende.',
    process: {
      badge: 'Unser Prozess',
      title: 'So arbeiten wir',
      subtitle: 'Ein optimierter Ansatz zur Ergebnislieferung für Ihre Kampagnen.',
      steps: [
        {
          step: '01',
          title: 'Analyse',
          desc: 'Wir analysieren Ihre Zielgruppe und Kampagnenziele.',
        },
        { step: '02', title: 'Strategie', desc: 'Individuelles Funnel-Design und Kanalauswahl.' },
        { step: '03', title: 'Start', desc: 'Kampagnen-Deployment mit Echtzeit-Monitoring.' },
        {
          step: '04',
          title: 'Optimierung',
          desc: 'Kontinuierliche Verbesserung basierend auf Performance-Daten.',
        },
      ],
    },
    ctaTitle: 'Benötigen Sie eine individuelle Lösung?',
    ctaSubtitle:
      'Unser Team kann maßgeschneiderte Lead-Generierungsstrategien für Ihre Branche und Ziele entwickeln.',
    requestQuote: 'Individuelles Angebot anfragen',
  },

  // For Partners Page
  partnersPage: {
    badge: 'Für Partner',
    title: 'Hochwertige Leads,',
    titleHighlight: 'Keine Kompromisse',
    subtitle:
      'Werden Sie Partner der führenden Performance-Marketing-Agentur für DSGVO-konforme, hochkonvertierende Leads nach Ihren Bedingungen.',
    requestLeadFlow: 'Lead-Flow anfragen',
    viewServices: 'Leistungen anzeigen',
    benefits: {
      badge: 'Partner-Vorteile',
      title: 'Warum mit uns zusammenarbeiten',
      subtitle: 'Alles was Sie brauchen, um Ihre Kundenakquise effizient zu skalieren.',
      items: {
        gdpr: {
          title: '100% DSGVO-konforme Leads',
          description:
            'Jeder Lead wird mit expliziter, dokumentierter Einwilligung gemäß deutschen und EU-Datenschutzstandards erfasst.',
        },
        filters: {
          title: 'Individuelle Traffic-Filter',
          description:
            'Definieren Sie Ihr ideales Kundenprofil und wir filtern den Traffic nach Ihren genauen Spezifikationen.',
        },
        billing: {
          title: 'CPL-basierte Abrechnung',
          description:
            'Zahlen Sie nur für qualifizierte Leads, die Ihre Kriterien erfüllen. Keine versteckten Gebühren, vollständige Transparenz.',
        },
        quality: {
          title: 'Qualitätskontrolle & Deduplizierung',
          description:
            'Fortschrittliche Algorithmen gewährleisten Lead-Frische und eliminieren Duplikate über alle Kampagnen.',
        },
        dashboard: {
          title: 'Echtzeit-Dashboard-Reporting',
          description:
            'Überwachen Sie Ihre Kampagnen 24/7 mit detaillierten Analysen und Performance-Metriken.',
        },
        account: {
          title: 'Dediziertes Account Management',
          description:
            'Arbeiten Sie direkt mit erfahrenen Fachleuten, die Ihre Geschäftsziele verstehen.',
        },
      },
    },
    howItWorks: {
      badge: 'Erste Schritte',
      title: 'Start in 3 einfachen Schritten',
      subtitle: 'Vom ersten Kontakt bis zu Live-Leads in nur 7 Tagen.',
      steps: [
        {
          title: 'Kriterien definieren',
          desc: 'Erzählen Sie uns von Ihrem idealen Kundenprofil, geografischem Targeting und Qualitätsanforderungen.',
        },
        {
          title: 'Individuelle Einrichtung',
          desc: 'Wir erstellen maßgeschneiderte Funnels und konfigurieren die Lieferung passend zu Ihrer CRM-Integration.',
        },
        {
          title: 'Qualifizierte Leads erhalten',
          desc: 'Beginnen Sie mit dem Empfang von Echtzeit-validierten Leads mit vollständiger Transparenz und Reporting.',
        },
      ],
    },
    faq: {
      badge: 'FAQ',
      title: 'Häufige Fragen',
      items: [
        {
          q: 'Wie hoch ist Ihr Mindestbestellvolumen?',
          a: 'Wir arbeiten typischerweise mit Werbetreibenden, die 1.000+ Leads pro Monat suchen, können aber kleinere Volumen für Tests anbieten.',
        },
        {
          q: 'Wie schnell können wir mit dem Lead-Empfang beginnen?',
          a: 'Die meisten Kampagnen gehen innerhalb von 5-7 Werktagen nach Vertragsunterzeichnung und technischer Einrichtung live.',
        },
        {
          q: 'Welche Abrechnungsmodelle bieten Sie an?',
          a: 'Wir arbeiten primär auf CPL-Basis (Cost Per Lead), mit CPA-Optionen für qualifizierte Partner.',
        },
        {
          q: 'Wie stellen Sie die DSGVO-Konformität sicher?',
          a: 'Alle Leads werden mit expliziter, dokumentierter Einwilligung durch DOI-Prozesse mit vollständigen Audit-Trails erfasst.',
        },
      ],
    },
    ctaTitle: 'Bereit für qualifizierte Leads?',
    ctaSubtitle:
      'Fordern Sie ein individuelles Lead-Flow-Angebot an, das auf Ihre Geschäftsanforderungen zugeschnitten ist.',
  },

  // Growth Chart
  growthChart: {
    title: 'Sehen Sie Ihre Wachstumstrajektorie mit Avalon X Media',
    subtitle:
      'Vergleichen Sie Ihr potenzielles Wachstum mit und ohne unsere Performance-Marketing-Expertise.',
    withoutAvalon: 'Ohne Avalon (3-7% monatlich)',
    withAvalon: 'Mit Avalon (11-24% monatlich)',
    fasterGrowth: '+240% Schneller',
    growthWithAvalon: 'Wachstum mit Avalon',
    description:
      'Ihr Unternehmen wächst schneller mit optimiertem, DSGVO-konformem Performance-Marketing.',
  },

  // About Page
  aboutPage: {
    badge: 'Über uns',
    title: 'Ihr Performance-Marketing-Partner',
    titleHighlight: '',
    subtitle:
      'Avalon X Media GmbH ist ein performance-orientierter Lead-Generierungspartner mit Sitz in Stuttgart. Wir kombinieren modernste Technologie mit tiefgreifender Marktexpertise, um messbare Ergebnisse für deutsche Werbetreibende zu liefern.',
    story: {
      badge: 'Unsere Geschichte',
      title: 'Exzellenz, Integrität, Partnerschaft',
      paragraphs: [
        'Avalon X Media entstand aus einer einfachen Erkenntnis: Deutsche Unternehmen benötigten einen zuverlässigen Partner, der die strengen Anforderungen des lokalen Marktes an Datenqualität und regulatorische Compliance wirklich versteht.',
        'Wir haben unser Unternehmen auf drei grundlegenden Säulen aufgebaut: technologische Exzellenz, regulatorische Integrität und langfristige Partnerschaft. Unser beschleunigtes Wachstum wird von einem Team getragen, das über tiefgreifende, spezialisierte Erfahrung in der Lead-Generierung verfügt – vereint durch die gemeinsame Mission, die Marken unserer Kunden nachhaltig zu stärken und voranzubringen.',
        'Unser proprietärer Technologie-Stack – einschließlich fortschrittlicher Validierungssysteme und einer internen Plattform-Infrastruktur – stellt sicher, dass jeder Lead höchsten Qualitätsstandards entspricht und gleichzeitig branchenführende Zustellraten sowie vollständige DSGVO-Konformität gewährleistet sind.',
      ],
    },
    values: {
      badge: 'Unsere Werte',
      title: 'Was uns antreibt',
      subtitle: 'Die Prinzipien, die jede unserer Entscheidungen leiten.',
      items: [
        {
          title: 'Performance zuerst',
          desc: 'Jede Kampagne wird für messbare Ergebnisse und ROI optimiert.',
        },
        {
          title: 'Datenethik',
          desc: 'Unerschütterliches Engagement für Datenschutz, Einwilligung und Compliance.',
        },
        {
          title: 'Innovation',
          desc: 'Kontinuierliche Investitionen in Technologie und Prozessverbesserung.',
        },
        {
          title: 'Partnerschaft',
          desc: 'Langfristige Beziehungen basierend auf Transparenz und Vertrauen.',
        },
      ],
    },
    team: {
      badge: 'Unser Team',
      title: 'Lernen Sie die Führung kennen',
      subtitle: 'Erfahrene Fachleute, die Ergebnisse für unsere Partner liefern.',
    },
    location: {
      badge: 'Standort',
      title: 'Mit Sitz in Stuttgart',
      subtitle:
        'Im Herzen von Deutschlands Innovationszentrum, perfekt positioniert, um den deutschen Markt zu bedienen.',
    },
    ctaTitle: 'Lassen Sie uns gemeinsam Großes schaffen',
    ctaSubtitle:
      'Bereit, Ihre Lead-Generierung mit einem vertrauenswürdigen deutschen Partner zu skalieren?',
    getInTouch: 'Kontakt aufnehmen',
  },

  // Contact Page
  contactPage: {
    badge: 'Kontakt',
    title: 'Starten wir ein Gespräch',
    subtitle:
      'Bereit, Ihre Lead-Generierung zu skalieren? Kontaktieren Sie uns und wir zeigen Ihnen, wie wir Ihrem Unternehmen beim Wachstum helfen können.',
    getInTouch: 'Kontakt aufnehmen',
    office: 'Büro',
    email: 'E-Mail',
    phone: 'Telefon',
    businessHours: 'Geschäftszeiten',
    businessHoursValue: 'Mo - Fr: 9:00 - 18:00 MEZ',
    bookCall: {
      title: 'Strategiegespräch buchen',
      description:
        'Vereinbaren Sie einen 30-minütigen Anruf, um Ihre Lead-Generierungsbedürfnisse zu besprechen.',
      button: 'Termin vereinbaren',
    },
    form: {
      fullName: 'Vollständiger Name',
      emailAddress: 'E-Mail-Adresse',
      company: 'Unternehmen',
      phoneNumber: 'Telefonnummer',
      subject: 'Betreff',
      expectedLeads: 'Erwartete Leads/Monat',
      message: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie uns von Ihren Lead-Generierungsbedürfnissen...',
      privacyNote: 'Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu.',
      sendMessage: 'Nachricht senden',
      sending: 'Wird gesendet...',
      successTitle: 'Nachricht gesendet!',
      successMessage:
        'Vielen Dank für Ihre Kontaktaufnahme. Wir melden uns innerhalb von 24 Stunden bei Ihnen.',
    },
  },

  // Imprint Page
  imprintPage: {
    title: 'Impressum',
    subtitle: 'Angaben gemäß § 5 TMG',
    backToHome: 'Zurück zur Startseite',
    managingDirector: 'Vertreten durch den Geschäftsführer',
    commercialRegister: 'Handelsregistereintrag',
    courtOfRegistration: 'Registergericht',
    registrationNumber: 'Registernummer',
    vatId: 'USt-IdNr.',
    contactTitle: 'Kontakt',
  },

  // Privacy Page
  privacyPage: {
    title: 'Datenschutzerklärung',
    subtitle: 'Privacy Policy',
    backToHome: 'Zurück zur Startseite',
    lastUpdated: 'Zuletzt aktualisiert: Mai 2025',
    sections: {
      controller: 'Verantwortlicher',
      generalInfo: 'Allgemeine Informationen zur Datenverarbeitung',
      generalInfoText:
        'Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Die Erhebung und Verarbeitung Ihrer Daten erfolgt ausschließlich in Übereinstimmung mit den gesetzlichen Vorschriften, insbesondere der DSGVO und dem Bundesdatenschutzgesetz (BDSG).',
      purposes: 'Zwecke und Rechtsgrundlage der Datenverarbeitung',
      purposesIntro: 'Ihre Daten können auf folgenden Rechtsgrundlagen verarbeitet werden:',
      purposesList: [
        'Vertragserfüllung oder vorvertragliche Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO)',
        'Erfüllung rechtlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO)',
        'Wahrung berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO)',
        'Einwilligung der betroffenen Person (Art. 6 Abs. 1 lit. a DSGVO)',
      ],
      collection: 'Erhebung und Speicherung personenbezogener Daten',
      collectionIntro:
        'Wir erheben und speichern personenbezogene Daten, wenn Sie diese über Anfragen, Registrierungen oder im Zusammenhang mit der Vertragsabwicklung übermitteln. Dies umfasst:',
      collectionList: [
        'Name',
        'Adresse',
        'E-Mail-Adresse',
        'Telefonnummer',
        'Zahlungsinformationen',
        'IP-Adresse',
      ],
      disclosure: 'Weitergabe von Daten an Dritte',
      disclosureIntro: 'Daten werden nur dann an Dritte übermittelt, wenn:',
      disclosureList: [
        'Sie Ihre Einwilligung gegeben haben',
        'Dies zur Vertragserfüllung erforderlich ist',
        'Wir gesetzlich dazu verpflichtet sind',
        'Ein berechtigtes Interesse besteht',
      ],
      rights: 'Rechte der betroffenen Personen',
      rightsIntro: 'Sie haben folgende Rechte gemäß DSGVO:',
      rightsList: [
        'Auskunftsrecht',
        'Recht auf Berichtigung',
        'Recht auf Löschung',
        'Recht auf Einschränkung der Verarbeitung',
        'Recht auf Datenübertragbarkeit',
        'Widerspruchsrecht',
        'Recht auf Widerruf der Einwilligung',
      ],
      retention: 'Datenspeicherung',
      retentionText:
        'Daten werden nur so lange gespeichert, wie es für den vorgesehenen Zweck erforderlich ist oder gesetzliche Aufbewahrungsfristen dies vorschreiben.',
      security: 'Datensicherheit',
      securityText:
        'Wir setzen geeignete technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Verlust oder Zerstörung zu schützen.',
      updates: 'Aktualisierungen und Änderungen',
      updatesText:
        'Diese Datenschutzerklärung gibt den Stand von Mai 2025 wieder. Zukünftige Aktualisierungen werden veröffentlicht unter:',
    },
  },

  // Footer
  footer: {
    company: 'Unternehmen',
    servicesTitle: 'Leistungen',
    legal: 'Rechtliches',
    privacyPolicy: 'Datenschutz',
    imprint: 'Impressum',
    termsOfService: 'AGB',
    allRightsReserved: 'Alle Rechte vorbehalten.',
  },
};
